export default ({ icon: iconData = { url: '' }, title = '' }) => `
    <a href="#">
        <div class="ad ad-sponsor-sticky">
            <div class="ad-sponsor-wrapper">
                <span class="sponsor-title">${title}</span><img class="sponsor-logo" src="${
    iconData.url
}">
            </div>
        </div>
    </a>
`;



/** WEBPACK FOOTER **
 ** ./src/ads/native-templates/sponsor.js
 **/